import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { environment } from '@app-environments/environment';
import { AuthService } from '@app-services/auth-service/auth.service';
import { BoardsService } from '@app-services/boarrds/boards.service';
import { LoginService } from '@app-services/login/login.service';
import { ScheduleService } from '@app-services/schedule/schedule.service';
import { SignupService } from '@app-services/signup/signup.service';
import { UserService } from '@app-services/user/user.service';
import * as moment from 'moment';
// import { IliteRegisterPopupComponent } from '@app-shared/components/ilite-register-popup/ilite-register-popup.component';
import { identity, isArray } from 'lodash-es';
import { NgxSpinnerService } from 'ngx-spinner';
import { isUserAdmin, setLoggedInUserData } from 'src/app/helpers/functions';
import { ClassService } from 'src/app/core/services/class.service';
import { TestRegistrationConfirmDialogComponent } from '@app-shared/components/test-registration-confirm-dialog/test-registration-confirm-dialog.component';
import { allowedExamNamesCT, apisDataCacheKeys, homeRoute } from '@app-constants/app.constants';
import { RegisterDialogComponent } from '@app-shared/components/register-dialog/register-dialog.component';
import { SubscriptionService } from '@app-services/subscription/subscription.service';
import { InviteEarnService } from '@app-services/invite-earn/invite-earn.service';
import { MyactivityService } from 'src/app/core/services/myactivity.service';
import { FirebaseService } from '@app-services/firebase/firebase.service';




export function startLearning(inp) {
  let {selectedExams, isILITE = false, regLiveClass = false, grade, ILITEData, urlData = {}} = inp;
  console.log(selectedExams)
  let obj = JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails));
  let Exams = [];
  selectedExams.forEach((exam) => {
    Exams.push({ examId: environment?.UAM_TO_CMS_CONVERSION?.find((ex) => ex?.CMS_Exam_id==exam?.examId && ex?.UAM_grade_id==obj?.grade?.gradeId)?.UAM_exam_id });
  });
  obj.exams = inp?.regLiveClass ? selectedExams : Exams;
  if(grade) obj.grade = inp?.regLiveClass ? inp?.grade : grade;
  obj.roles = [1];
  let serverTime = localStorage.getItem('serverTime');
  let current_time = moment.unix(Number(serverTime)).format("YYYY-MM-DD HH:mm:ss");

  obj.userType = {
    "active": true,
    "createdTime": new Date(current_time).getTime(),
    "name": "student",
    "tenantId": 1,
    "userTypeId": 1
  };

  let page = "WEB_IL_SITE";
  if(urlData?.courses) {
    let x = urlData?.courses?.replace(/[^a-z]/i,'').toUpperCase(); 
    page = isILITE ? urlData?.origin?.toUpperCase() : x.indexOf("JEE") > -1 ? "JEE":  x.indexOf("NEET") > -1 ? "NEET": "NA";
  }
        
  obj.origin = {
      "page": page,
      "platform": "web",
      "productId": 1
  }
  let serviceName = obj.isProfileComplete? 'userService': 'userService';//'signupService';
  let methodName = obj.isProfileComplete? 'updateUserDetails': 'updateUserDetails';//'register';
  this[serviceName][methodName](obj, { register: true }).subscribe((data) => {
    if (data) {
      localStorage?.setItem("token",data?.accessToken)
      let dataDto = obj.isProfileComplete? data?.userDto: data?.userDto; //data;
      let referralCode=JSON.parse(localStorage.getItem('reffCode'));
      let fullName=dataDto?.firstName+' '+dataDto?.lastName;
      let gradeByName = dataDto?.grade?.name?.replace('st', '')?.replace('nd', '')?.replace('rd', '')?.replace('th', '');
        this.userService.setMobileAndName({
          phone: dataDto?.phone, isdCode: dataDto?.isdCode, firstName: dataDto?.firstName, lastName: dataDto?.lastName,
          whatsappConsent: dataDto?.whatsappConsent, userId: dataDto?.userId, profilePhoto: dataDto?.profilePhoto, grade: Number(gradeByName)
        });
        this.userService.setUserTypes(dataDto?.userType);
        this.userService.updateRequestedUserData(dataDto);
        
        this.classService.syncStudent();
        console.log(dataDto);
        let whatsappData = {
          isdCode: dataDto?.isdCode,
          name: dataDto?.firstName,
          phone: dataDto?.phone, 
          "liveClassesUrl": "Live classes will be launching soon",
          "assessmentsUrl": window.location.origin+'/assesments'
        }
        this.userService.whatsAppWelcome(whatsappData).subscribe(res => console.log(res));
        //Todo here the refcode send if its present
       if(referralCode.referralCode){
        this._inviteNdEarn.sendNewRegisteredData(referralCode.referralCode,dataDto?.userId,fullName).subscribe(res => {
          console.log(res), localStorage.setItem('referralTriggered','DOne!!!');
          localStorage.removeItem('pgName');
          this._inviteNdEarn.getOwnerDetails(referralCode.referralCode).subscribe(ownerRes => {
           let firebasePayload = {
              "ActivityDateTime": moment().utc().format("YYYY-MM-DD HH:mm:ss"),
              "ActivityEvent": 279,
              "Fields":{"mx_Custom_1":`${ownerRes?.firstName} ${ownerRes?.lastName}`},
              "FirstName": this.userInfo?.firstName,
              "LastName": this.userInfo?.lastName,
              "environment": environment?.branch,
              "phone": this.userInfo?.phone,
              "productId": 1,
              "type": "Activity"
            }
            this.firebaseService.getSqsValue().then((firebaseRSP) => {
              this.userService.sendSQSMsg(firebaseRSP?.access_key, firebaseRSP?.secret_key, firebaseRSP,firebasePayload);
             // ? this will call after calling referral api
              setTimeout(() => {
                if(environment.redirectToSubscription){
                  window.location.replace("/subscription/subscriptionPackages"); //? redirecting to subscription
                }
              }, 200);
            }).catch((e) => {
              console.log(e);
              if(environment.redirectToSubscription){
                window.location.replace("/subscription/subscriptionPackages"); //? redirecting to subscription
              }
            });
  
          });
        });
        
       }
        isUserAdmin(this.userService).then((bool) => {
          if(!bool) {
            this.userService.saveRewardHistory(1).subscribe(res => console.log(res));
          };
        })
      
      localStorage.setItem('targetExamName', dataDto?.exams?.[0]?.name?.replace(' ', '').toUpperCase());
      if(isILITE && ILITEData?.exam == 'ilite') {
        //register api call and after subscribe if response true open register successful 
        let dateArray = [];
        if (isArray(ILITEData.date)) {
          let index = 0;
          let timeSlot;
          ILITEData.date.forEach((ele) => {
            let m = '12';
            let year = '2021';
            let date = ele;
            timeSlot = '10:00 AM';
            if(ILITEData.timeSlot[index]){
              switch(ILITEData.timeSlot[index]){
                case '0':
                  timeSlot= '10:00 AM';
                  break;
                case '1':
                  timeSlot = '05:00PM';
                  break;
                case '2':
                  timeSlot = '02:00 PM';
                  break;
                case '3':
                  timeSlot = '12:00 PM';
                  break;
                case '4':
                  timeSlot = '03:00 PM';
                  break;
              }
            }
            if(['2','3'].indexOf(ele) > -1){
              m = '01';
              year = '2022';
              date = ele == '2' ? '02' : '03';
            }
            // if(ele?.trim() == '17' || ele?.trim() == '18') m = '12';
            dateArray.push(`${year}-${m}-${date} ${timeSlot}`)
            index++;
          })
          
          let obj = {
            studentid: dataDto?.phone,
            phone:  dataDto?.phone,
            admissionNumber: dataDto?.phone,
            rulename: "ilite",
            grade: ILITEData.grade, // GRADE name send 
            coursetype: ILITEData.courses, // JEE, NEET
            examtype: "SCHOLARSHIPTEST",
            span: dateArray,  //2021-11-04 02:00 PM
            duration: "90",
            testtype: "",
            pretype: "",
            timeboundtest: "",
            origin:ILITEData.origin,
          }
          let exName = ILITEData.courses.replace(/[^a-z]/ig,'').toUpperCase();
          localStorage.setItem('regILITEData', JSON.stringify(obj))
            let grade='';
            let body = {
              examName :exName == "FOUNDATIONTEST" ?  "Foundationtest": exName == "APTITUDETEST"? "Aptitudetest": exName,
              grade:ILITEData.grade.replace(/[^0-9]/g,''),
              producttype : 'score',
              year:[],
              pageUrl: "studentPortal_Subscriptions",
            }
            switch(ILITEData.grade){
              case '3rd':
              case '4th':
              case '5th':
                body.year = [2022]
                break;
              case '6th':
              case '7th':
              case '8th':
                body.year = [2022]
                break;
              case '9th':
                body.year = [2025]
                break;
              case '10th':
                body.year = [2024]
                break;
              case '11th':
                body.year = [2023]
                break;
              case '12th':
                body.year = [2022]
                break;
              case '13th':
                body.year = [2022]
                break;
              default:
                body.year = [2022]
                break;
            }
            
            this.SubscriptionService.totalexamTypePackages(body).subscribe((res)=>{
              if(res){
                res.forEach(element => {
                  if(element.productName == 'Score'){
                    console.log(element)
                    let obj = JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails));

                    this.SubscriptionService.getPackagesSubscriptionByUserID({subscription_id:element.packageSubscriptionDto[0].id,user_id:obj?.userId}).subscribe((resp:any)=>{
                      if(resp){
                        let dialogRef = this.dialog.open(TestRegistrationConfirmDialogComponent, {
                          height: '280px',
                          width: '500px',
                          data: {
                            message1: 'Oops!',
                            message2:'This is a one time subscription only, you have already purschased it.',
                          }
                        });
                        dialogRef.afterClosed().subscribe(()=>{
                          window.location.href = homeRoute+"ilite";
                        })
                      }else{
                        element.validDate =  new Date(`2021-12-${ILITEData.date[0]}`);
                        element.examTime = timeSlot;
                         this.router.navigate(['./subscription/billing'],{state:  {...element,...element.packageSubscriptionDto[0],...[]}})
                      }
                    })
                  }
                });
              } else {

              }
            }, (error)=>{
              console.log(error);
              alert("Server error: Please try again: " + (error?.error?.message || error?.error?.text));
            })
        }
      } else if (regLiveClass) {
        const _eclassId = ILITEData.liveclassId;
        let userInfo = JSON.parse(localStorage.getItem('mobile_and_name'))
        this.classService.getClassDetails(_eclassId).subscribe((data) => {
          if (data && data?.data?.name) {
            const _classDetails = Object.assign({}, data.data);


            let serverTime = localStorage.getItem('serverTime');
            let current_time = moment.unix(Number(serverTime)).format("YYYY-MM-DD HH:mm:ss");

            let _crntTime = Math.round(new Date(current_time).getTime() / 1000);

            if (
              Object.keys(_classDetails.meeting).length > 0 &&
              _classDetails?.meeting?.id != undefined
            ) {
              if (
                _classDetails.startDate > _crntTime ||
                _classDetails.meeting.status == 'waiting' ||
                _classDetails.meeting.status == 'teacher_started'
              ) {
                this.classService.classRegistre(_eclassId, userInfo.userId).subscribe((res) => {
                  if (res) {
                    localStorage.setItem('targetExam', ILITEData.exam)
                    localStorage.setItem('targetExamName', ILITEData.exam)
                    const config: MatDialogConfig = {
                      width: '500px',
                      height: '300px',
                      data: {
                        title: _classDetails.name,
                        description: `You have successfully registered for the class`
                      },
                    };
                    let dialogRef = this.dialog.open(RegisterDialogComponent, config)
                    dialogRef.afterClosed().subscribe((res) => {
                      this.router.navigate(['/dashboard/liveclass'])
                    })
                  } else {
                    this.router.navigate(['/dashboard/liveclass']);
                  }
                },
                  (err) => {
                    console.log(err);
                    alert("Server error: Please try again: " + (err?.error?.message || err?.error?.text));
                  });
              } else if (_classDetails.startDate < _crntTime) {
                if (_classDetails.meeting.status == 'started') {
                  this.classService.classRegistre(_eclassId, userInfo.userId).subscribe((res) => {
                    if(res){
                      localStorage.setItem('leaveUrl', `${this.webURL}/dashboard/liveclass`);
                      const url = `/live-class/${_eclassId}/student-live-class/${_classDetails.meeting.id}`;
                      window.location.href = url;
                    } else {
                      alert('Registration Failed. Please try again.')
                    }
                  }, (error)=>{
                    console.log(error);
                    alert("Server error: Please try again: " + (error?.error?.message || error?.error?.text));
                  })
                } else if (_classDetails.meeting.status == 'ended') {
                  alert('Class already ended. Please check your past classes to rewatch');
                  this.router.navigate(['/dashboard/liveclass']);
                }
              }
            }
          }
        },
          (err) => {
            console.log(err);
            alert("Server error: Please try again: " + (err?.error?.message || err?.error?.text));
          })
      } else if (localStorage.getItem('packageDetails')){
        let packageDeatails = localStorage.getItem('packageDetails');
        this.routeToplanPage(JSON.parse(packageDeatails));
      } else {
        let userData = this.userService.getMobileAndName()
        if(userData.grade <3) {
          this.router.navigate(['/dashboard/assessment'], {state: {newUser: true}});
        } else {
          this.router.navigate(['/dashboard'], {state: {newUser: true}});
        }
      }
    }

    
    // setTimeout(()=>{
    //   this.AchievementsService.badgeInvokeSubject.next();
    // },1000);
  }, (error)=>{
    console.log(error);
    alert("Server error: Please try again: " + (error?.error?.message || error?.error?.text));
  })
}

@Component({
  selector: 'app-target-exam',
  templateUrl: './target-exam.component.html',
  styleUrls: ['./target-exam.component.css']
})
export class TargetExamComponent implements OnInit {
  exams: any;
  selectedExams = [];
  grades
  gradeData
  registerUser = false
  isILITE: boolean = false;
  iliteTargetExam: any;
  iliteTargetExamId: any;
  examsFetched: boolean;
  startLearning = startLearning;
  navExtra: any;
  userInfo: any;
  constructor(
    private targetExamService: BoardsService,
    private userService: UserService,
    private router: Router,
    private loginService: LoginService,
    private signupService: SignupService,
    private dialog: MatDialog,
    private scheduleService: ScheduleService,
    private authService: AuthService,
    private spinner: NgxSpinnerService, 
    private classService: ClassService,
    private SubscriptionService: SubscriptionService,
    private _inviteNdEarn:InviteEarnService,
    private AchievementsService: MyactivityService,
    private firebaseService: FirebaseService
  ) {
    this.navExtra = this.router.getCurrentNavigation()?.extras?.state;
   }

  ngOnInit(): void {
    this.getTargetExamsList();
    this.userInfo = JSON.parse(
      localStorage.getItem(apisDataCacheKeys.userDetails)
    );
  }

  getTargetExamsList() {
    this.spinner.show();
    let obj = JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails));
    const cmsGradeId = environment?.UAM_TO_CMS_CONVERSION?.find((x) => x?.UAM_grade_id == obj?.grade?.gradeId)?.CMS_grade_id;
    const cmsGradeIds = [cmsGradeId];
    const userGrade = obj?.grade?.name?.replace(/[^0-9]/g, '');
    this.targetExamService.fetchCMSTargetExamList(cmsGradeIds).subscribe((data: any) => {
      this.examsFetched = true;
      this.exams = data?.exams?.filter(ex => {
        const isCBSE = ex?.name?.replace(/[^a-z]/ig, '').toUpperCase().includes("CBSE");
        if(isCBSE) {
          ex.displayName = "CBSE";
        }
        if(isCBSE){
          return (allowedExamNamesCT[userGrade]?.indexOf('CBSE') > -1 ) && ex?.examStatusName == "Active";
        }else{
          return (allowedExamNamesCT[userGrade]?.indexOf(ex?.name?.replace(/[^a-z]/ig, '').toUpperCase()) > -1 ) && ex?.examStatusName == "Active";
        }
        // return (allowedExamNamesCT[userGrade]?.indexOf(ex?.name?.replace(/[^a-z]/ig, '').toUpperCase()) > -1 || isCBSE) && ex?.examStatusName == "Active";
      })
      .sort((a, b) => allowedExamNamesCT[userGrade]?.indexOf(a?.name?.replace(/[^a-z]/ig, '').toUpperCase())<allowedExamNamesCT[userGrade]?.indexOf(b?.name?.replace(/[^a-z]/ig, '').toUpperCase()) ? -1 : 1);
      this.spinner.hide();
    });
  }

  selectedTargetExamp(exam) {
    let index = this.selectedExams.findIndex((ind) => ind.examId == exam.examId);
    if (index > -1) {
      this.selectedExams.splice(index, 1);
    } else {
      this.selectedExams.push(exam);
    }
  }

  routeToplanPage(pack: any) {
    this.SubscriptionService.subscriptionSelectedData.liveclass_courseID =
      pack?.packagesCourseDtoList?.[0]?.courseId ? (pack?.courseId == 1 ? null : pack?.courseId) : null;
    pack.packageName = pack?.name;
    pack.amount = pack?.maxValue;
    pack.validDate = pack?.packageValidity;
    this.router.navigate(['../enroll-subscription/enroll-proceed-to-payment'], {
      state: { ...pack },
    });

    let arr = { "selectedPackage": pack };
    localStorage.setItem(apisDataCacheKeys.payments, JSON.stringify(arr));
  }
}
